import { render, staticRenderFns } from "./FlowForwardToSender.vue?vue&type=template&id=3f8ff5fe"
import script from "./FlowForwardToSender.vue?vue&type=script&lang=js"
export * from "./FlowForwardToSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports